import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { itemExistence } from '../../redux/actions/purchaseOrders';

import { Button, Text, Small, Panel, H3, H4, Table, TableFigure, Dropdown, Input, Box, Badge, Textarea } from '@bigcommerce/big-design';
import { CheckIcon, WarningIcon } from '@bigcommerce/big-design-icons';

import LoadingSpinner from '../partials/LoadingSpinner';

const ReceivingOrderLineItem = ({
	payload,
	purchaseOrderLine,
	receivedItems,
  updateReceived,
  updateTaxAdjustment,
  receiveAll,
  submitted,
  unverifiedLineItems,
  confirmedLineItems,
  missingLineItems,
  settings,
  verifyItemExistence
}) => {
	useEffect(() => {
    verifyItemExistence(payload, purchaseOrderLine.id, purchaseOrderLine.product_id, purchaseOrderLine.variant_id);
  }, []);

	return(
		<div className="has-hover sku-line">
      <strong>{ purchaseOrderLine.source_name }</strong>
      <div className="flex-container">
        <div className="flex-1">
          { purchaseOrderLine.source_image_url && <img src={purchaseOrderLine.source_image_url} /> }
          { !purchaseOrderLine.source_image_url && <Text>No image</Text>}
        </div>

        <div className="flex-2">
          { purchaseOrderLine?.source_options?.map(option =>
            <>
              <strong>{ option.option_display_name || option.display_name }</strong>: <Badge label={ option.label || option.display_value } /><br/>
            </>
          )}

          { (unverifiedLineItems.indexOf(purchaseOrderLine.id) >= 0) &&
          		<LoadingSpinner size="xxSmall" statusText="Searching BigCommerce..." />
          }
          { (confirmedLineItems.indexOf(purchaseOrderLine.id) >= 0) &&
          	<div className="flex-container">
              <CheckIcon color="success" size="medium" />
              <Small>Exists in BigCommerce</Small>
            </div>
          }
          { (missingLineItems.indexOf(purchaseOrderLine.id) >= 0) &&
          	<div className="flex-container">
              <WarningIcon color="warning" size="medium" />
              <Small>Missing in BigCommerce</Small>
            </div>
          }
        </div>

        <div className="flex-2">
          <strong>Expected Quantity</strong>: { purchaseOrderLine.count }
          { !!purchaseOrderLine.remaining_count && 
            <>
              <br/>
              <strong>Remaining Expected Quantity</strong>: { purchaseOrderLine.remaining_count }
              <Button
                variant="subtle"
                onClick={() => receiveAll(purchaseOrderLine)}
                disabled={(missingLineItems.indexOf(purchaseOrderLine.id) >= 0) || (unverifiedLineItems.indexOf(purchaseOrderLine.id) >= 0)}
              >
                Receive All
              </Button>
            </>
          }
          { settings?.settings?.pack_quantities && parseInt(purchaseOrderLine.pack_quantity) > 1 &&
            <>
              <br/>
              <strong>Pack Quantity</strong>: {purchaseOrderLine.pack_quantity}
            </>
          }
          { !purchaseOrderLine.remaining_count && 
            <>
              <br/>
              <strong>Remaining Expected Quantity</strong>: 0
            </>
          }
          <br/>
          <strong>Supplier SKU</strong>: { purchaseOrderLine.supplier_sku }<br/>
          <strong>SKU</strong>: { purchaseOrderLine.source_sku }<br/>
          <strong>UPC</strong>: { purchaseOrderLine.source_upc }<br/>
          <br/>
          <strong>Unit Cost</strong>: { purchaseOrderLine.supplier_price }<br/>
          { purchaseOrderLine.adjusted_tax && <><strong>Adjusted Line Tax</strong>: { purchaseOrderLine.adjusted_tax }<br/></> }

        </div>

        <div className="flex-2">
          <Input
            id={`scan-count-${purchaseOrderLine.id}`}
            required
            label="Receive Quantity"
            onChange={(event) => updateReceived(event, purchaseOrderLine.id)}
            placeholder=""
            type="number"
            min="0"
            value={receivedItems[purchaseOrderLine.id]?.count || 0}
            disabled={submitted || ((missingLineItems.indexOf(purchaseOrderLine.id) >= 0) || (unverifiedLineItems.indexOf(purchaseOrderLine.id) >= 0))}
          />
          { !!(receivedItems[purchaseOrderLine.id]?.count && (parseFloat(receivedItems[purchaseOrderLine.id]?.count) > parseFloat(purchaseOrderLine.remaining_count || purchaseOrderLine.count))) &&
            <div className="flex-container">
              <WarningIcon color="warning" size="medium" />
              <Small>Quantity is higher than expected</Small>
            </div>
          }
          { !!(receivedItems[purchaseOrderLine.id]?.count && (parseFloat(receivedItems[purchaseOrderLine.id]?.count) === parseFloat(purchaseOrderLine.remaining_count || purchaseOrderLine.count))) &&
            <div className="flex-container">
              <CheckIcon color="success" size="medium" />
              <Small>Quantity matches</Small>
            </div>
          }

          <Input
            id={`update-adjustment-tax-cost-${purchaseOrderLine.id}`}
            required
            label="Update Tax Adjustment"
            onChange={(event) => updateTaxAdjustment(event, purchaseOrderLine.id)}
            placeholder=""
            type="number"
            min="0"
            value={receivedItems[purchaseOrderLine.id]?.adjustedLineTax}
            disabled={submitted || ((missingLineItems.indexOf(purchaseOrderLine.id) >= 0) || (unverifiedLineItems.indexOf(purchaseOrderLine.id) >= 0))}
          />
        </div>
      </div>
    </div>

  )
}


const mapStateToProps = state => ({
  settings: state.settings,
  unverifiedLineItems: state.purchaseOrders.unverifiedLineItems,
	confirmedLineItems: state.purchaseOrders.confirmedLineItems,
	missingLineItems: state.purchaseOrders.missingLineItems
});

const mapDispatchToProps = (dispatch) => ({
  verifyItemExistence: (payload, itemId, productId, variantId) => dispatch(itemExistence(payload, itemId, productId, variantId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceivingOrderLineItem);
